module.exports = __webpack_public_path__ + "assets/images/amira_growth_alert_modal_open.93402c96e6e1b1a380c7dc3c3a80739f.svg";